import { ComponentProps, ElementType, ReactNode } from 'react';
import cn from 'classnames';
import styles from './keto-typography.module.css';

export enum KetoTypographyVariant {
  HEADLINE_1 = 'headline-1',
  HEADLINE_2 = 'headline-2',
  HEADLINE_3 = 'headline-3',
  BODY_1 = 'body-1',
  BODY_2 = 'body-2',
  TITLE = 'title',
}

type KetoTypographyOwnProps<E extends ElementType = ElementType> = {
  children: ReactNode;
  variant: KetoTypographyVariant;
  className?: string;
  tag?: E;
};

type KetoTypographyProps<E extends ElementType> = KetoTypographyOwnProps<E> &
  Omit<ComponentProps<E>, keyof KetoTypographyOwnProps>;

const defaultElement = 'p';

export default function KetoTypography<
  E extends ElementType = typeof defaultElement,
>({ tag, variant, children, className, ...props }: KetoTypographyProps<E>) {
  const TagName = tag || defaultElement;

  return (
    <TagName
      {...props}
      className={cn(className, {
        [styles.headline_1]: variant === KetoTypographyVariant.HEADLINE_1,
        [styles.headline_2]: variant === KetoTypographyVariant.HEADLINE_2,
        [styles.headline_3]: variant === KetoTypographyVariant.HEADLINE_3,
        [styles.body_1]: variant === KetoTypographyVariant.BODY_1,
        [styles.body_2]: variant === KetoTypographyVariant.BODY_2,
        [styles.title]: variant === KetoTypographyVariant.TITLE,
      })}
    >
      {children}
    </TagName>
  );
}
